export default [
  // TMP FIX Redirection
  {
    path: 'invoices',
    name: 'invoices',
    redirect: { name: 'invoicesissued' }
  },
  {
    icon: 'bell',
    path: 'invoicesissued',
    name: 'invoicesissued',
    component: () => import('@/views/invoices/InvoicesIssued.vue'),
    meta: { registerNavFromMenu: true, status: 99999 }
  },
  {
    path: 'invoicesissued/:type/:idFacturae/:idInvoice/details',
    name: 'invoicesissued/details',
    component: () => import('@/views/invoices/Invoice.vue'),
    meta: { secondaryMenu: 'invoicesissued', registerNavFromMenu: false, recibida: false }
  },
  {
    path: 'invoicesissued/:type/:idFacturae/:idInvoice/groups',
    name: 'invoicesissued/groups',
    component: () => import('@/views/invoices/GroupsByInvoice.vue'),
    meta: { secondaryMenu: 'invoicesissued', registerNavFromMenu: false, recibida: false }
  },
  {
    path: 'invoicesissued/:type/:idFacturae/:idInvoice/historical',
    name: 'invoicesissued/historical',
    component: () => import('@/views/historical/InvoiceHistorical.vue'),
    meta: { secondaryMenu: 'invoicesissued', registerNavFromMenu: false, recibida: false }
  },
  // {
  //   path: 'invoicesissued/new',
  //   name: 'invoicesissued/new',
  //   component: () => import('@/views/invoices/NewInvoice.vue'),
  //   meta: { secondaryMenu: 'invoice/new', registerNavFromMenu: false }
  // },
  {
    icon: 'bell',
    path: 'invoicesreceived',
    name: 'invoicesreceived',
    component: () => import('@/views/invoices/InvoicesReceived.vue'),
    meta: { registerNavFromMenu: true, status: 99999 }
  },
  {
    path: 'invoicesreceived/:type/:idFacturae/:idInvoice/details',
    name: 'invoicesreceived/details',
    component: () => import('@/views/invoices/Invoice.vue'),
    meta: { secondaryMenu: 'invoicesreceived', registerNavFromMenu: false, recibida: true }
  },
  {
    path: 'invoicesreceived/:type/:idFacturae/:idInvoice/groups',
    name: 'invoicesreceived/groups',
    component: () => import('@/views/invoices/GroupsByInvoice.vue'),
    meta: { secondaryMenu: 'invoicesreceived', registerNavFromMenu: false, recibida: true }
  },
  {
    path: 'invoicesreceived/:type/:idFacturae/:idInvoice/historical',
    name: 'invoicesreceived/historical',
    component: () => import('@/views/historical/InvoiceHistorical.vue'),
    meta: { secondaryMenu: 'invoicesreceived', registerNavFromMenu: false, recibida: true }
  },
  // {
  //   path: 'invoicesreceived/new',
  //   name: 'invoicesreceived/new',
  //   component: () => import('@/views/invoices/NewInvoice.vue'),
  //   meta: { secondaryMenu: 'invoice/new', registerNavFromMenu: false }
  // },
  {
    icon: 'bell',
    path: 'invoicesissuing',
    name: 'invoicesissuing',
    component: () => import('@/views/invoices/InvoicesIssuing.vue'),
    meta: { registerNavFromMenu: true }
  },
]
